
<div *ngIf="podcast !== null" class="root">

  <img [src]="podcast.mainImage | imageurl" alt="cover">

  <span class="title">{{podcast.title}}</span>

</div>
